var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { useAuth } from '@/lib/AuthContext';
import { useI18n } from '@/lib/i18n';
import * as styles from './AuthPage.module.scss';
export var AuthPage = function (_a) {
    var onBack = _a.onBack;
    var _b = useAuth(), signIn = _b.signIn, signUp = _b.signUp;
    var t = useI18n().t;
    var _c = useState(true), isLogin = _c[0], setIsLogin = _c[1];
    var _d = useState(''), email = _d[0], setEmail = _d[1];
    var _e = useState(''), password = _e[0], setPassword = _e[1];
    var _f = useState(''), fullName = _f[0], setFullName = _f[1];
    var _g = useState(''), error = _g[0], setError = _g[1];
    var _h = useState(false), loading = _h[0], setLoading = _h[1];
    var _j = useState(''), success = _j[0], setSuccess = _j[1];
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError('');
                    setSuccess('');
                    setLoading(true);
                    if (!email || !password) {
                        setError(t.enterCredentials);
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    if (!isLogin && !fullName) {
                        setError(t.enterName);
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    if (!isLogin) return [3 /*break*/, 2];
                    return [4 /*yield*/, signIn(email, password)];
                case 1:
                    error_1 = (_a.sent()).error;
                    if (error_1)
                        setError(translateError(error_1, t));
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, signUp(email, password, fullName)];
                case 3:
                    error_2 = (_a.sent()).error;
                    if (error_2) {
                        setError(translateError(error_2, t));
                    }
                    else {
                        setSuccess(t.registerSuccess);
                    }
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter')
            handleSubmit();
    };
    return (_jsx("div", { className: styles.page, children: _jsxs("div", { className: styles.card, children: [onBack && (_jsxs("button", { className: styles.backBtn, onClick: onBack, children: ["\u2190 ", t.back] })), _jsxs("div", { className: styles.logoRow, children: [_jsx("div", { className: styles.logoMark, children: "CB" }), _jsx("span", { className: styles.logoText, children: "ClientBase" })] }), _jsx("div", { className: styles.subtitle, children: isLogin ? t.loginTitle : t.registerTitle }), _jsxs("form", { onSubmit: function (e) { e.preventDefault(); handleSubmit(); }, autoComplete: "on", children: [!isLogin && (_jsxs(_Fragment, { children: [_jsx("label", { className: styles.label, children: t.fullName }), _jsx("input", { className: styles.input, type: "text", placeholder: "John Smith", value: fullName, onChange: function (e) { return setFullName(e.target.value); }, autoComplete: "name", autoFocus: true })] })), _jsx("label", { className: styles.label, children: t.email }), _jsx("input", { className: styles.input, type: "email", placeholder: "you@example.com", value: email, onChange: function (e) { return setEmail(e.target.value); }, autoComplete: "email", autoFocus: isLogin }), _jsx("label", { className: styles.label, children: t.password }), _jsx("input", { className: styles.input, type: "password", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022", value: password, onChange: function (e) { return setPassword(e.target.value); }, autoComplete: isLogin ? 'current-password' : 'new-password' }), error && _jsx("div", { className: styles.error, children: error }), success && _jsx("div", { className: styles.success, children: success }), _jsx("button", { type: "submit", className: styles.submitBtn, disabled: loading, children: loading ? t.loading : isLogin ? t.signIn : t.signUp })] }), _jsxs("div", { className: styles.switchRow, children: [isLogin ? t.noAccount : t.hasAccount, _jsx("button", { className: styles.switchBtn, onClick: function () { setIsLogin(!isLogin); setError(''); setSuccess(''); }, children: isLogin ? t.create : t.signIn })] })] }) }));
};
function translateError(msg, t) {
    if (msg.includes('Invalid login credentials'))
        return t.wrongCredentials;
    if (msg.includes('User already registered'))
        return t.emailExists;
    if (msg.includes('Password should be'))
        return t.shortPassword;
    if (msg.includes('invalid email'))
        return t.invalidEmail;
    return msg;
}
